import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "assignParentCheckBox", "assignParentLabel",
    "createParentCheckBox", "createParentLabel",
    "assignForm", "newForm",
    "parentSelection",
  ]

  connect() {
    this.toggleSelect()
  }

  toggleSelect() {
    const value = this.parentSelectionTarget.value

    if (value === "assign_existing_parents") {
      this.assignParentCheckBoxTarget.checked = true
      this.createParentCheckBoxTarget.checked = false

      this.assignFormTarget.classList.remove("hidden")
      this.newFormTarget.classList.add("hidden")
    } else if (value === "create_new_parent") {
      this.createParentCheckBoxTarget.checked = true
      this.assignParentCheckBoxTarget.checked = false

      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.remove("hidden")
    } else {
      this.assignParentCheckBoxTarget.checked = false
      this.createParentCheckBoxTarget.checked = false

      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.add("hidden")
    }
  }
}
